// SupervisorDashboard.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import SupervisorNavbar from "./SupervisorNavbar";
import ProductionStats from "./ProductionStats";
import DailyLogsList from "./DailyLogsList";
import DailyLogForm from "./DailyLogForm";
import ReportGenerator from "./ReportGenerator";
import Popup from "../../components/ui/Popup";

function SupervisorDashboard() {
    const [currentPage, setCurrentPage] = useState("Dashboard");
    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "success"
    });

    const showPopup = (message, type = "success") => {
        setPopup({
            show: true,
            message,
            type
        });
    };

    const closePopup = () => {
        setPopup({
            ...popup,
            show: false
        });
    };

    return (
        <Section>
            <SupervisorNavbar className="navbar" pageTitle={currentPage} onNavigate={setCurrentPage} />

            <ContentWrapper>
                {currentPage === "Dashboard" && (
                    <DashboardContent>
                        <ProductionStats showPopup={showPopup} />
                    </DashboardContent>
                )}
                {currentPage === "DailyLog" && <DailyLogForm showPopup={showPopup} />}
                {currentPage === "ViewLogs" && <DailyLogsList showPopup={showPopup} />}
                {currentPage === "Reports" && <ReportGenerator showPopup={showPopup} />}

                {popup.show && (
                    <Popup
                        message={popup.message}
                        type={popup.type}
                        onClose={closePopup}
                        autoClose={true}
                        duration={4000}
                    />
                )}
            </ContentWrapper>
        </Section>
    );
}

export default SupervisorDashboard;

const Section = styled.section`
    display: flex;
    width: 100vw;  /* Full viewport width */
    height: 100vh;  /* Full viewport height */
    overflow: hidden;
    background-color: #f0f2f5;
`;

const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    width: 100%;
    margin-left: 240px;
    max-width: 100vw;  /* Ensure no margin on the right */
`;

const DashboardContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
